export const properties = {
  authToken: window?.Liferay?.authToken,
  siteGroupId: window?.themeDisplay?.getSiteGroupId(),
  userId: window?.themeDisplay?.getUserId(),
  doAsUserId: window?.Liferay?.ThemeDisplay?.getDoAsUserIdEncoded(),
  languageId: window?.themeDisplay?.getLanguageId(),
  companyId: window?.themeDisplay?.getCompanyId(),
};
